<template>
  <el-table-column
    prop="representative_sale_receipt_number"
    sortable="custom"
    label="Bizonylatszám"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.representative_sale_receipt_number }}
    </template>
  </el-table-column>
</template>

<script>

export default {
  propName: 'receipt_number',
};
</script>
